import React, { useEffect, useRef } from 'react'
import gsap from 'gsap';
import { ReactComponent as LogoType } from '../../images/logo-variant-1.svg'

export default function Logo() {
    const wrapper = useRef(null);

    useEffect( () => {
      const [elements] = wrapper.current.children;
      const polygon1 = elements.getElementById('Polygon1');
      const polygon2 = elements.getElementById('Polygon2');

    const tl = gsap.timeline({defaults: { ease: 'power3.inOut'}});
    tl.fromTo(polygon1, {x: "-=10", yoyo: true}, { x: "+=10", duration: 2, repeat: -1, yoyo: true})
    tl.fromTo(polygon2, {x: "+=10", yoyo: true}, { x: "-=10", duration: 2, repeat: -1, yoyo: true}, "-=2")
    }, [])

    return (
        <div className="Logo__container" ref={wrapper}>
            <LogoType/>
            <h1 className="logo__text">Shoppy Live</h1>
        </div>
    )
}
